<template>
  <!--begin::Aside-->
  <div :class="{'simple__sidebar': isSimpleModel, 'non__simple__sidebar': isSimpleModel == false }">
    <div v-if="isSimpleModel" id="kt_aside" class="aside" style="width: 60px; margin-right: 60px" data-kt-drawer="true" data-kt-drawer-name="aside"
         data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="auto"
         data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_aside_toggle">
      <!--begin::Logo-->
      <div class="d-flex justify-content-center">
        <a class="btn btn-icon btn-active-color-primary" id="kt_aside_toggle" @click="isSimpleModel = !isSimpleModel">
          <!--begin::Svg Icon | path: icons/duotune/abstract/abs015.svg-->
          <span class="svg-icon svg-icon-2x me-n1"  style="color: white">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z" fill="currentColor" />
                      <path opacity="0.3" d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z" fill="currentColor" />
                    </svg>
                  </span>
        </a>
      </div>
      <div class="aside-logo flex-column-auto pt-10 pt-lg-20" id="kt_aside_logo">
        <a href="/app/index">
          <img alt="Logo" src="/assets/main/simle__sidebar__icon.png" class="h-50px"/>
        </a>
      </div>
      <!--end::Logo-->
      <!--begin::Nav-->
      <div class="aside-menu flex-column-fluid pt-0 pb-7 py-lg-10" id="kt_aside_menu" style="align-items: start;">
        <!--begin::Aside menu-->
        <div id="kt_aside_menu_wrapper" class="w-100 hover-scroll-overlay-y scroll-ps d-flex show" data-kt-scroll="true"
             data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
             data-kt-scroll-wrappers="#kt_aside, #kt_aside_menu" data-kt-scroll-offset="0">
          <div id="kt_aside_menu"
               class="menu menu-column menu-title-gray-600 menu-state-primary menu-state-icon-primary menu-state-bullet-primary menu-icon-gray-400 menu-arrow-gray-400 fw-semibold fs-6 my-auto"
               data-kt-menu="true">

            <div class="menu-item text-center">
              <router-link to="/app/index">
                <div class="menu-item menu-accordion" :class="{'here' : this.$router.currentRoute.value.name =='Main'}">
                  <a href="" class="menu-link">
                  <span class="menu-icon">
												<i class="fonticon-house fs-1"></i>
											</span>

<!--                    <span class="menu-title fs-3">메인화면</span>-->
                  </a>
                </div>
              </router-link>
            </div>

            <div class="menu-item text-center">
              <router-link to="/app/collection">
                <div class="menu-item menu-accordion"
                     :class="{'here' : this.$router.currentRoute.value.name =='Collection'}">
                  <!--begin::Menu link-->
                  <a href="" class="menu-link">
                    <!--begin::Icon-->
                    <span class="menu-icon">
												<i class="fonticon-app-store fs-1"></i>
											</span>
                    <!--end::Icon-->
                    <!--begin::Title-->

<!--                    <span class="menu-title fs-3">상품 등록</span>-->

                    <!--end::Title-->
                    <!--begin::Badge-->

                    <!--end::Badge-->
                  </a>
                  <!--end:::Menu link-->
                </div>
              </router-link>
            </div>
            <div class="menu-item text-center">
              <router-link @click.native="nameCheck" to="/app/uploadList">
                <div class="menu-item menu-accordion"
                     :class="{'here' : this.$router.currentRoute.value.name =='UploadList'}">
                  <!--begin::Menu link-->
                  <a href="" class="menu-link">
                    <!--begin::Icon-->
                    <span class="menu-icon">
												<i class="fonticon-image fs-1"></i>
											</span>
                    <!--end::Icon-->
                    <!--begin::Title-->
<!--                    <span class="menu-title fs-3">등록 리스트</span>-->
                    <!--end::Title-->
                    <!--begin::Badge-->

                    <!--end::Badge-->
                  </a>
                  <!--end:::Menu link-->
                </div>
              </router-link>
            </div>
            <div class="menu-item text-center">
              <router-link @click.native="nameCheck" to="/app/setting">
                <div class="menu-item menu-accordion"
                     :class="{'here' : this.$router.currentRoute.value.name =='Setting'}">
                  <!--begin::Menu link-->
                  <a href="" class="menu-link">
                    <!--begin::Icon-->
                    <span class="menu-icon">
												<i class="fonticon-setting fs-1"></i>
											</span>
                    <!--end::Icon-->
                    <!--begin::Title-->
<!--                    <span class="menu-title fs-3">설정</span>-->
                    <!--end::Title-->
                    <!--begin::Badge-->

                    <!--end::Badge-->
                  </a>
                  <!--end:::Menu link-->
                </div>
              </router-link>
            </div>
            <div class="menu-item text-center" v-if="userModel.role=='admin'">
              <router-link @click.native="nameCheck" to="/app/admin">
                <div class="menu-item menu-accordion"
                     :class="{'here' : this.$router.currentRoute.value.name =='Admin'}">
                  <!--begin::Menu link-->
                  <a href="" class="menu-link">
                    <!--begin::Icon-->
                    <span class="menu-icon">
												<i class="fonticon-alarm fs-1"></i>
											</span>
                    <!--end::Icon-->
                    <!--begin::Title-->
                    <span class="menu-title fs-3"></span>
                    <!--end::Title-->
                    <!--begin::Badge-->

                    <!--end::Badge-->
                  </a>
                  <!--end:::Menu link-->
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <!--end::Aside menu-->
      </div>
      <!--end::Nav-->
      <!--begin::Footer-->
      <div class="aside-footer flex-column-auto pb-5 pb-lg-10" id="kt_aside_footer">
        <!--begin::Menu-->

        <div class="d-flex flex-center scroll-px" data-bs-toggle="tooltip" data-bs-placement="right"
             data-bs-dismiss="click" title="로그아웃">
          <button type="button" class="btn btn-custom" style="width: 30px; height: 40px" data-kt-menu-trigger="click" data-kt-menu-overflow="true"
                  data-kt-menu-placement="top-start" @click="logout">
            <!--begin::Svg Icon | path: icons/duotune/arrows/arr076.svg-->
            <span class="svg-icon svg-icon-2x">
									<svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<rect opacity="0.3" width="12" height="2" rx="1" transform="matrix(-1 0 0 1 15.5 11)"
                          fill="currentColor"/>
										<path
                        d="M13.6313 11.6927L11.8756 10.2297C11.4054 9.83785 11.3732 9.12683 11.806 8.69401C12.1957 8.3043 12.8216 8.28591 13.2336 8.65206L16.1592 11.2526C16.6067 11.6504 16.6067 12.3496 16.1592 12.7474L13.2336 15.3479C12.8216 15.7141 12.1957 15.6957 11.806 15.306C11.3732 14.8732 11.4054 14.1621 11.8756 13.7703L13.6313 12.3073C13.8232 12.1474 13.8232 11.8526 13.6313 11.6927Z"
                        fill="currentColor"/>
										<path
                        d="M8 5V6C8 6.55228 8.44772 7 9 7C9.55228 7 10 6.55228 10 6C10 5.44772 10.4477 5 11 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H11C10.4477 19 10 18.5523 10 18C10 17.4477 9.55228 17 9 17C8.44772 17 8 17.4477 8 18V19C8 20.1046 8.89543 21 10 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H10C8.89543 3 8 3.89543 8 5Z"
                        fill="currentColor"/>
									</svg>
								</span>
            <!--end::Svg Icon-->
          </button>
          <!--begin::Menu 2-->
          <div
              class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px"
              data-kt-menu="true">
            <!--begin::Menu item-->
            <div class="menu-item px-3">
              <div class="menu-content fs-6 text-dark fw-bold px-3 py-4">Quick Actions</div>
            </div>
            <!--end::Menu item-->
            <!--begin::Menu separator-->
            <div class="separator mb-3 opacity-75"></div>
            <!--end::Menu separator-->
            <!--begin::Menu item-->
            <div class="menu-item px-3">
              <a href="#" class="menu-link px-3">New Ticket</a>
            </div>
            <!--end::Menu item-->
            <!--begin::Menu item-->
            <div class="menu-item px-3">
              <a href="#" class="menu-link px-3">New Customer</a>
            </div>
            <!--end::Menu item-->
            <!--begin::Menu item-->
            <div class="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-start">
              <!--begin::Menu item-->
              <a href="#" class="menu-link px-3">
                <span class="menu-title">New Group</span>
                <span class="menu-arrow"></span>
              </a>
              <!--end::Menu item-->
              <!--begin::Menu sub-->
              <div class="menu-sub menu-sub-dropdown w-175px py-4">
                <!--begin::Menu item-->
                <div class="menu-item px-3">
                  <a href="#" class="menu-link px-3">Admin Group</a>
                </div>
                <!--end::Menu item-->
                <!--begin::Menu item-->
                <div class="menu-item px-3">
                  <a href="#" class="menu-link px-3">Staff Group</a>
                </div>
                <!--end::Menu item-->
                <!--begin::Menu item-->
                <div class="menu-item px-3">
                  <a href="#" class="menu-link px-3">Member Group</a>
                </div>
                <!--end::Menu item-->
              </div>
              <!--end::Menu sub-->
            </div>
            <!--end::Menu item-->
            <!--begin::Menu item-->
            <div class="menu-item px-3">
              <a href="#" class="menu-link px-3">New Contact</a>
            </div>
            <!--end::Menu item-->
            <!--begin::Menu separator-->
            <div class="separator mt-3 opacity-75"></div>
            <!--end::Menu separator-->
            <!--begin::Menu item-->
            <div class="menu-item px-3">
              <div class="menu-content px-3 py-3">
                <a class="btn btn-primary btn-sm px-4" href="#">Generate Reports</a>
              </div>
            </div>
            <!--end::Menu item-->
          </div>
          <!--end::Menu 2-->
        </div>
        <!--end::Menu-->
      </div>
      <!--end::Footer-->
    </div>
    <div v-else id="kt_aside" class="aside" data-kt-drawer="true" data-kt-drawer-name="aside"
       data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="auto"
       data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_aside_toggle">
    <!--begin::Logo-->
    <div class="container d-flex flex-stack">
      <a class="btn btn-icon btn-active-color-primary" id="kt_aside_toggle" @click="isSimpleModel = !isSimpleModel">
        <!--begin::Svg Icon | path: icons/duotune/abstract/abs015.svg-->
        <span class="svg-icon svg-icon-2x me-n1"  style="color: white">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z" fill="currentColor" />
                      <path opacity="0.3" d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z" fill="currentColor" />
                    </svg>
                  </span>
      </a>
    </div>
    <div class="aside-logo flex-column-auto pt-10" id="kt_aside_logo">
      <a href="/app/index">
        <img alt="Logo" src="/assets/login/logo.png" width="170" class="mt-13 mb-15"/>
      </a>
    </div>
    <!--end::Logo-->
    <!--begin::Nav-->
    <div class="aside-menu flex-column-fluid pt-0 pb-7" id="kt_aside_menu" style="align-items: start;">
      <!--begin::Aside menu-->
      <div id="kt_aside_menu_wrapper" class="w-100 hover-scroll-overlay-y scroll-ps d-flex show" data-kt-scroll="true"
           data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
           data-kt-scroll-wrappers="#kt_aside, #kt_aside_menu" data-kt-scroll-offset="0">
        <div id="kt_aside_menu"
             class="menu menu-column menu-title-gray-600 menu-state-primary menu-state-icon-primary menu-state-bullet-primary menu-icon-gray-400 menu-arrow-gray-400 fw-semibold fs-6 my-auto"
             style="margin-top:21% !important;"
             data-kt-menu="true">

          <div class="menu-item text-center">
            <router-link to="/app/index">
              <div class="menu-item menu-accordion" :class="{'here' : this.$router.currentRoute.value.name =='Main'}">
                <a href="" class="menu-link">
                  <span class="menu-icon">
												<i class="fonticon-house fs-1"></i>
											</span>

                  <span class="menu-title fs-3">메인화면</span>
                </a>
              </div>
            </router-link>
          </div>

          <div class="menu-item text-center">
            <router-link to="/app/collection">
              <div class="menu-item menu-accordion"
                   :class="{'here' : this.$router.currentRoute.value.name =='Collection'}">
                <!--begin::Menu link-->
                <a href="" class="menu-link">
                  <!--begin::Icon-->
                  <span class="menu-icon">
												<i class="fonticon-app-store fs-1"></i>
											</span>
                  <!--end::Icon-->
                  <!--begin::Title-->

                  <span class="menu-title fs-3">상품 등록</span>

                  <!--end::Title-->
                  <!--begin::Badge-->

                  <!--end::Badge-->
                </a>
                <!--end:::Menu link-->
              </div>
            </router-link>
          </div>
          <div class="menu-item text-center">
            <router-link @click.native="nameCheck" to="/app/uploadList">
              <div class="menu-item menu-accordion"
                   :class="{'here' : this.$router.currentRoute.value.name =='UploadList'}">
                <!--begin::Menu link-->
                <a href="" class="menu-link">
                  <!--begin::Icon-->
                  <span class="menu-icon">
												<i class="fonticon-image fs-1"></i>
											</span>
                  <!--end::Icon-->
                  <!--begin::Title-->
                  <span class="menu-title fs-3">등록 리스트</span>
                  <!--end::Title-->
                  <!--begin::Badge-->

                  <!--end::Badge-->
                </a>
                <!--end:::Menu link-->
              </div>
            </router-link>
          </div>
          <div class="menu-item text-center">
            <router-link @click.native="nameCheck" to="/app/setting">
              <div class="menu-item menu-accordion"
                   :class="{'here' : this.$router.currentRoute.value.name =='Setting'}">
                <!--begin::Menu link-->
                <a href="" class="menu-link">
                  <!--begin::Icon-->
                  <span class="menu-icon">
												<i class="fonticon-setting fs-1"></i>
											</span>
                  <!--end::Icon-->
                  <!--begin::Title-->
                  <span class="menu-title fs-3">설정</span>
                  <!--end::Title-->
                  <!--begin::Badge-->

                  <!--end::Badge-->
                </a>
                <!--end:::Menu link-->
              </div>
            </router-link>
          </div>
          <div class="menu-item text-center" v-if="userModel.role=='admin'">
            <router-link @click.native="nameCheck" to="/app/admin">
              <div class="menu-item menu-accordion"
                   :class="{'here' : this.$router.currentRoute.value.name =='Admin'}">
                <!--begin::Menu link-->
                <a href="" class="menu-link">
                  <!--begin::Icon-->
                  <span class="menu-icon">
												<i class="fonticon-setting fs-1"></i>
											</span>
                  <!--end::Icon-->
                  <!--begin::Title-->
                  <span class="menu-title fs-3">관리자</span>
                  <!--end::Title-->
                  <!--begin::Badge-->

                  <!--end::Badge-->
                </a>
                <!--end:::Menu link-->
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <!--end::Aside menu-->
    </div>
    <!--end::Nav-->
    <!--begin::Footer-->
    <div class="aside-footer flex-column-auto pb-5 pb-lg-10" id="kt_aside_footer">
      <!--begin::Menu-->
      <div class="d-flex flex-center w-100 scroll-px" data-bs-toggle="tooltip" data-bs-placement="right"
           data-bs-dismiss="click" title="로그아웃">
        <button type="button" class="btn btn-custom" data-kt-menu-trigger="click" data-kt-menu-overflow="true"
                data-kt-menu-placement="top-start" @click="logout">
          <!--begin::Svg Icon | path: icons/duotune/arrows/arr076.svg-->
          <span class="svg-icon svg-icon-2x">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<rect opacity="0.3" width="12" height="2" rx="1" transform="matrix(-1 0 0 1 15.5 11)"
                          fill="currentColor"/>
										<path
                        d="M13.6313 11.6927L11.8756 10.2297C11.4054 9.83785 11.3732 9.12683 11.806 8.69401C12.1957 8.3043 12.8216 8.28591 13.2336 8.65206L16.1592 11.2526C16.6067 11.6504 16.6067 12.3496 16.1592 12.7474L13.2336 15.3479C12.8216 15.7141 12.1957 15.6957 11.806 15.306C11.3732 14.8732 11.4054 14.1621 11.8756 13.7703L13.6313 12.3073C13.8232 12.1474 13.8232 11.8526 13.6313 11.6927Z"
                        fill="currentColor"/>
										<path
                        d="M8 5V6C8 6.55228 8.44772 7 9 7C9.55228 7 10 6.55228 10 6C10 5.44772 10.4477 5 11 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H11C10.4477 19 10 18.5523 10 18C10 17.4477 9.55228 17 9 17C8.44772 17 8 17.4477 8 18V19C8 20.1046 8.89543 21 10 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H10C8.89543 3 8 3.89543 8 5Z"
                        fill="currentColor"/>
									</svg>
								</span>
          <!--end::Svg Icon-->
        </button>
        <!--begin::Menu 2-->
        <div
            class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px"
            data-kt-menu="true">
          <!--begin::Menu item-->
          <div class="menu-item px-3">
            <div class="menu-content fs-6 text-dark fw-bold px-3 py-4">Quick Actions</div>
          </div>
          <!--end::Menu item-->
          <!--begin::Menu separator-->
          <div class="separator mb-3 opacity-75"></div>
          <!--end::Menu separator-->
          <!--begin::Menu item-->
          <div class="menu-item px-3">
            <a href="#" class="menu-link px-3">New Ticket</a>
          </div>
          <!--end::Menu item-->
          <!--begin::Menu item-->
          <div class="menu-item px-3">
            <a href="#" class="menu-link px-3">New Customer</a>
          </div>
          <!--end::Menu item-->
          <!--begin::Menu item-->
          <div class="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-start">
            <!--begin::Menu item-->
            <a href="#" class="menu-link px-3">
              <span class="menu-title">New Group</span>
              <span class="menu-arrow"></span>
            </a>
            <!--end::Menu item-->
            <!--begin::Menu sub-->
            <div class="menu-sub menu-sub-dropdown w-175px py-4">
              <!--begin::Menu item-->
              <div class="menu-item px-3">
                <a href="#" class="menu-link px-3">Admin Group</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-3">
                <a href="#" class="menu-link px-3">Staff Group</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-3">
                <a href="#" class="menu-link px-3">Member Group</a>
              </div>
              <!--end::Menu item-->
            </div>
            <!--end::Menu sub-->
          </div>
          <!--end::Menu item-->
          <!--begin::Menu item-->
          <div class="menu-item px-3">
            <a href="#" class="menu-link px-3">New Contact</a>
          </div>
          <!--end::Menu item-->
          <!--begin::Menu separator-->
          <div class="separator mt-3 opacity-75"></div>
          <!--end::Menu separator-->
          <!--begin::Menu item-->
          <div class="menu-item px-3">
            <div class="menu-content px-3 py-3">
              <a class="btn btn-primary btn-sm px-4" href="#">Generate Reports</a>
            </div>
          </div>
          <!--end::Menu item-->
        </div>
        <!--end::Menu 2-->
      </div>
      <!--end::Menu-->
    </div>
    <!--end::Footer-->
  </div>
  </div>
  <!--end::Aside-->
</template>

<script>
export default {
  data(){
    return {
      isSimpleModel: false,
      isOpen : false,
      myRelationAccount: null,
      myCollectionLimit: null,
      userModel : {
        username: ''
      },
      collectCount :0,
      uploadCount: 0,
      recommendersCount:0,
      masterAccount: '확인중',
      myPlanName : '확인중',
      clickMenuName: null,
    }
  },
  async created(){
    if(this.getUser() == null) this.userModel = await this.setupUser()
    else this.userModel = await this.getUser()
  },
  methods:{
    nameCheck(){
      this.clickMenuName = this.$router.currentRoute.value.name
    },
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    logout(){
      this.authStore.logout()
    },
    subMenuOpen(){
      this.isOpen = !this.isOpen
    }
  }

}
</script>

<style scoped>
.simple__sidebar {
  background-color: black;
}
@media (max-width: 991px){
  .simple__sidebar {
  }
}

@media (min-width: 992px) {
  .simple__sidebar {
    margin-right: 60px;
  }
}

@media (max-width: 991px){
  .non__simple__sidebar {
  }
}

@media (min-width: 992px) {
  .non__simple__sidebar {
    margin-right: 230px;
  }
}

@media (max-width: 991px){
  .aside{
    display: block;
    height: 100%;
    font-size: 12px;
    width:160px;
    margin-right: 0px !important;
  }
}
</style>